// Per-app Stimulus manifest. This file is NOT synced (it is listed in copyutil
// exceptions.txt) because each app registers its own controllers below.
// Shared controllers live in ./fvbox_controllers.js (synced from fvbox).

import { application } from "fvbox/application"
import { registerFvboxControllers } from "fvbox"

// Shared controllers (hello, turbomodal, timezone-detector, ...)
registerFvboxControllers(application)

// Eanis-specific controllers
import UploadFormController from "./upload_form_controller"
application.register("upload-form", UploadFormController)

import RepositoryStreamController from "./repository_stream_controller"
application.register("repository-stream", RepositoryStreamController)

import SolutionProgressController from "./solution_progress_controller"
application.register("solution-progress", SolutionProgressController)

import AddDocumentController from "./add_document_controller"
application.register("add-document", AddDocumentController)

import RepositoryViewController from "./repository_view_controller"
application.register("repository-view", RepositoryViewController)
